<h3 mat-dialog-title>{{ data.title }}</h3>
@if (data.message) {
  <mat-dialog-content>{{ data.message }}</mat-dialog-content>
}
<mat-dialog-actions>
  <button matButton (click)="cancel()">Fermer</button>
  <button matButton="filled" (click)="confirm()">{{ data.confirmLabel }}</button>
</mat-dialog-actions>
